import "@arco-design/web-react/es/Carousel/style";
import _Carousel from "@arco-design/web-react/es/Carousel";
import React from 'react';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
export default function LoginBanner() {
  const t = useLocale(locale);
  const data = [{
    slogan: '饭划算霸王餐',
    subSlogan: '天上没有免费的午餐,饭划算有',
    image: 'http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png'
  }];
  return /*#__PURE__*/React.createElement(_Carousel, {
    className: styles.carousel,
    animation: "fade"
  }, data.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: `${index}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-item']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-title']
  }, item.slogan), /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-sub-title']
  }, item.subSlogan), /*#__PURE__*/React.createElement("img", {
    alt: "banner-image",
    className: styles['carousel-image'],
    src: item.image
  })))));
}